
<br />

<div class="oroDefault">

  <br />
  <br />

  <h2>
    <b>Contact Us</b>
  </h2>

  <br />

  <div class="oroContent">

    <h4>Support Hours</h4>

    <br />

    <h4>Monday – Friday</h4>
    <h4>7 AM – 5 PM (CST)</h4>
    <br />
    <h4>877-345-1210</h4>

  </div>

  <p>
    <br />
    <button class="btn btn-primary" (click)="gotoHub()" [disabled]="this.isDisabled" title="Go Back">Back</button>
  </p>
</div>
<br />


